import { TRIP_IN_PROGRESS_STATUSES } from './tripInProgressStatuses';
import { TRIP_STATUS_CODES } from './tripStatuses';

export const POST_ASSIGNMENT_TRIP_STATUSES = Object.freeze([
  TRIP_STATUS_CODES.ASSIGNMENT_ACCEPTED,
  TRIP_STATUS_CODES.ASSIGNMENT_DISPATCHED,
  ...TRIP_IN_PROGRESS_STATUSES,
]);
